import { feedItems } from "@/mocks/home";

const badgeStyle: Record<string, string> = {
  更新: "bg-primary-100 text-primary-800 border-primary-200",
  有声: "bg-secondary-100 text-secondary-800 border-secondary-200",
  合集: "bg-accent-100 text-accent-900 border-accent-300",
  修订: "bg-background-200 text-foreground-700 border-background-300",
  列表: "bg-secondary-100 text-secondary-800 border-secondary-200",
  榜单: "bg-accent-100 text-accent-900 border-accent-300",
};

export default function FeedSection() {
  return (
    <section id="feed" className="w-full border-b border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-16">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <span className="flex items-center gap-2 text-xs font-label tracking-wide text-primary-600">
              <i className="ri-live-line" />
              更新快讯
            </span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              追踪每条新动态
            </h2>
          </div>
          <button
            type="button"
            className="inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-label text-foreground-700 transition-colors hover:bg-background-50"
          >
            <i className="ri-notification-3-line" />
            订阅更新提醒
          </button>
        </div>

        <ol className="mt-10 grid grid-cols-1 gap-x-10 gap-y-0 md:grid-cols-2">
          {feedItems.map((item, i) => (
            <li key={item.title} className="relative flex gap-4 pb-8 last:pb-0">
              <div className="relative flex flex-col items-center">
                <span
                  className={`mt-1 flex h-3 w-3 shrink-0 items-center justify-center rounded-full ${
                    i === 0 ? "bg-accent-500" : "bg-primary-400"
                  }`}
                />
                <span className="mt-1 w-px flex-1 bg-background-300" />
              </div>
              <div className="flex-1 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 md:p-5">
                <div className="flex flex-wrap items-center gap-2">
                  <span
                    className={`rounded-md border px-2 py-0.5 text-xs font-label ${
                      badgeStyle[item.badge] ?? "bg-background-200 text-foreground-700 border-background-300"
                    }`}
                  >
                    {item.badge}
                  </span>
                  <span className="text-xs font-label text-foreground-500">{item.time}</span>
                </div>
                <h3 className="mt-2 font-heading text-base font-bold text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-sm leading-6 text-foreground-600">{item.desc}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}